/**
 * ECSR-944: Ordergroove "Deliver Every" frequency dropdown on the PDP, presentation only.
 *
 * The dropdown text is the native <select> two open shadow roots down
 * (og-offer[location="custom-location"] og-select-frequency > og-select > select).
 * Document CSS cannot reach it, and it resets letter-spacing to `normal` and is pinned
 * to `line-height: 1.3` by og-select's own styles. This adds one shared stylesheet to
 * each such og-select shadow root so the spec's letter-spacing (1%) and line-height
 * (192%) apply to the text itself. The vertical padding that custom-product.css uses to
 * imitate the 192% row height is zeroed in the same rule, so the row stays 30.72px.
 *
 * It only adds styles: no listeners, values, options or behaviour are touched. If a
 * root is unavailable it does nothing, and the CSS fallback in custom-product.css stays.
 */
(function () {
  if (!window.customElements || !window.ShadowRoot) return;

  var CSS_TEXT =
    'select { letter-spacing: 0.01em; line-height: 1.92; padding-top: 0; padding-bottom: 0; }';
  var OFFER_SELECTOR = 'og-offer[location="custom-location"]';
  var styled = new WeakSet();
  var watchedHosts = new WeakSet();
  var sharedSheet = null;

  try {
    if ('adoptedStyleSheets' in ShadowRoot.prototype && 'replaceSync' in CSSStyleSheet.prototype) {
      sharedSheet = new CSSStyleSheet();
      sharedSheet.replaceSync(CSS_TEXT);
    }
  } catch (e) {
    sharedSheet = null;
  }

  function styleRoot(root) {
    if (!root || styled.has(root)) return;
    try {
      if (sharedSheet) {
        root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sharedSheet);
      } else {
        var style = document.createElement('style');
        style.textContent = CSS_TEXT;
        root.appendChild(style);
      }
      styled.add(root);
    } catch (e) {
      /* Root not styleable: leave the vendor rendering as is. */
    }
  }

  function styleHost(host) {
    var hostRoot = host.shadowRoot;
    if (!hostRoot) return;
    hostRoot.querySelectorAll('og-select').forEach(function (select) {
      styleRoot(select.shadowRoot);
    });
    // og-select can be (re)created when the host re-renders; watch its root once.
    if (!watchedHosts.has(host)) {
      watchedHosts.add(host);
      new MutationObserver(function () {
        styleHost(host);
      }).observe(hostRoot, { childList: true, subtree: true });
    }
  }

  function scan(offer) {
    offer.querySelectorAll('og-select-frequency').forEach(styleHost);
  }

  function init() {
    var offers = document.querySelectorAll(OFFER_SELECTOR);
    if (!offers.length) return;
    Promise.all([
      customElements.whenDefined('og-select-frequency'),
      customElements.whenDefined('og-select'),
    ])
      .then(function () {
        offers.forEach(function (offer) {
          scan(offer);
          // The offer template renders client-side and re-renders (e.g. on variant change).
          new MutationObserver(function () {
            scan(offer);
          }).observe(offer, { childList: true, subtree: true });
        });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
